import type { DashboardWidgetConfiguration } from './widget-definition';

export const financeCashflowSankeyWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.cashflow-sankey",
  name: "Cash flow and profit",
  description: "Posted revenue and costs flowing to profit, followed by working-capital, investing, and financing movements flowing to closing cash.",
  apps: [
    "finance",
  ],
  template: "sankey",
  query: {
    kind: "component",
    owner: "finance-cashflow",
  },
  inputs: {
    title: "Cash flow and profit",
  },
  dummyData: {},
  limits: {
    minWidth: 8,
    maxWidth: 12,
    minHeight: 5,
    maxHeight: 8,
    defaultWidth: 12,
    defaultHeight: 6,
  },
};
